import { useQuery } from "@tanstack/react-query";
import { hasPermission } from "../entities/access";
import { documentApprovalsKey } from "./approvalStatus";
import { shellBootstrapQuery } from "./bootstrap";
import type { ShellServices } from "./services";

export function useDocumentApprovals(
  services: ShellServices,
  documentId: string,
) {
  const bootstrap = useQuery(shellBootstrapQuery(services));
  const allowed = hasPermission(
    { permissions: bootstrap.data?.permissions ?? [] },
    "document-workflow.approvals.view",
  );
  const approvals = useQuery({
    queryKey: documentApprovalsKey(documentId),
    queryFn: () => services.approvals!.documentApprovals(documentId),
    enabled: services.approvals !== undefined && allowed,
    retry: false,
  });
  return { bootstrap, approvals, allowed };
}
